





















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Plan } from "@foxone/api/src/models/hfox";
import { USDT_ASSET } from "hfox/constants";

@Component
class IncreaseAction extends Vue {
  @Prop() plan!: Plan;

  @Getter("hfox/getBalance") balance!: number;

  dialog = false;

  noticeDialog = false;

  loading = false;

  amount = "";

  symbol = USDT_ASSET.symbol;

  get rules() {
    const limit = this.limit;
    const balance = this.balance;
    const limitText = this.$t("common.amount.limit", {
      max: this.limit.max,
      min: this.limit.min
    });
    const requireText = this.$t("common.amount.required");
    const balanceText = this.$t("common.balance.inffrence");
    return [
      v => !!v || requireText,
      v => Number(v) <= Number(limit.max) || limitText,
      v => Number(v) >= Number(limit.min) || limitText,
      v => Number(v) <= Number(balance) || balanceText
    ];
  }

  get limit() {
    return {
      max: this.plan.etf.max_funds,
      min: this.plan.etf.min_funds
    };
  }

  get funds() {
    return this.plan.funds;
  }

  get quicks() {
    const funds = this.funds;
    const limit = this.limit;
    return Array.from([1, 2, 5])
      .map(n => {
        const v = n * Number(funds);
        return v > Number(limit.max) ? limit.max : v.toFixed();
      })
      .filter((_, index, arr) => {
        return !(index > 0 && arr[index - 1] === limit.max);
      });
  }

  get hint() {
    return this.$t("hfox.increase-hint", {
      balance: this.balance,
      min: this.limit.min,
      max: this.limit.max,
      asset: this.symbol
    });
  }

  @Watch("dialog")
  handleClose(value) {
    if (!value) {
      this.reset();
    }
  }

  @Watch("noticeDialog")
  handleNoticeClose(value) {
    if (!value) {
      this.$emit("refresh");
    }
  }

  async handleSubmit() {
    const form: any = this.$refs.form;
    const valid = form.validate();
    if (valid) {
      this.loading = true;
      await this.requestIncrease();
      this.loading = false;
    }
  }

  handleQuickFill(n) {
    this.amount = n;
  }

  handleCancel() {
    this.dialog = false;
  }

  reset() {
    const form: any = this.$refs.form;
    form.reset();
    this.amount = "";
  }

  async requestIncrease() {
    try {
      await this.$api.hfox.requestCreatePlanSchedules(this.plan.id + "", {
        funds: this.amount,
        trigger: true
      });
      this.dialog = false;
      this.noticeDialog = true;
    } catch (error) {
      if (error.status === 404) {
        this.$common.utils.helper.errorHandler(this, {
          message: this.$t("common.not-in-service") as string,
          code: 404
        });
      } else {
        this.$common.utils.helper.errorHandler(this, error);
      }
    }
  }
}
export default IncreaseAction;
